import PortalLayout from "@/components/PortalLayout";
import CrewTransferIntelligenceTool from "@/pages/CrewTransferIntelligence";

const PortalCrewTransferIntelligence = () => {
  return (
    <PortalLayout>
      <div className="space-y-6">
        <div>
          <h1 className="text-2xl font-display font-bold text-foreground">Crew Transfer Intelligence</h1>
          <p className="text-muted-foreground text-sm mt-1">
            Compare helicopter vs CTV crew transfer costs with live fuel pricing, configurable scenarios, and branded prospect reports.
          </p>
        </div>
        <CrewTransferIntelligenceTool skipGate skipLayout hideWeatherTab hideReportTab />
      </div>
    </PortalLayout>
  );
};

export default PortalCrewTransferIntelligence;
